import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { urls } from '../../utils/url-utils';
import { errorHandl } from '../../utils/network-utils';
import * as moment from 'moment-timezone';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public KEY_TOKEN: 'token';
  private user;

  constructor(private http: HttpClient) {
  }


  staffComponentRoles = {
    company: 'Full Access',
    accountant: 'Biller',
    credential: 'Credentialer',
    mdispatcher: 'Manager (RM,SM,ASM)',
    rdispatcher: 'Restricted (RM,SM,ASM)',
    dispatcher: 'Dispatcher',
    mcallcenter: 'Call Center Manager',
    rcallcenter: 'Call Taker'
  }

  accountStatus = {
    active: 'Active',
    inactive: 'InActive',
  }

  fleetAccountStatus = {
    active: 'Active',
    inactive: 'InActive',
  }

  driverComponentProfileRoles = {
    driver: 'Driver',
    dispatcher: 'Dispatcher'
  }



  login(email, password, roles): Observable<any> {
    const user = {
      email,
      password,
      roles
    };
    return this.http.post<any>(urls.BASE_URL + urls.SIGNIN_URL, user)
      .pipe(
        catchError(errorHandl)
      );
  }

  VerifyToken(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.PROFILE_URL)
      .pipe(
        catchError(errorHandl)
      );
  }

  forgetPasswordRequestwithNgx(payload: any): Observable<any> {

    return this.http.post<any>(urls.BASE_URL + urls.FORGOT_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  // saving token
  setToken(data: any): void {
    try {
      localStorage.setItem('token', JSON.stringify(data));
      localStorage.setItem('last_activity_time', Date.now().toString());
      localStorage.setItem('login_event', Date.now().toString());
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  removeToken(): void {
    try {
      localStorage.removeItem('token');
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  getToken(key: string) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }


  getUserData() {
    return this.user;
  }

  CheckLoginValidation(user, isAuthLoggedIn: boolean) {
    if (user == null) {
      this.user = null;
    } else {
      this.user = user;
      moment.tz.setDefault(user.timeZone);

    }
  }

  private googleKeys$: Observable<any> = null;

  getGoogleKeys(): Observable<any> {
    if (!this.googleKeys$) {
      this.googleKeys$ = this.http.get<any>("https://gckeys.nemtplatform.com/get-server-key")
        .pipe(
          shareReplay(1),
          catchError((err) => {
            this.googleKeys$ = null;
            return errorHandl(err);
          })
        );
    }
    return this.googleKeys$;
  }

  resetPassword(token: string, role: string, payload: any) {
    return this.http.post(`${urls.BASE_URL + urls.RESET_URL}/${token}/${role}`, payload);
  }

  verifyResetToken(token: string, role: string) {
    return this.http.get(`${urls.BASE_URL + urls.RESET_URL}/${token}/${role}`);
  }

  setAuthToken(data: any): void {
    try {
      localStorage.setItem('auth-token', JSON.stringify(data));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  getAuthToken() {
    try {
      const authToken = localStorage.getItem('auth-token');
      return authToken ? JSON.parse(authToken) : '';
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }

  removeAuthToken(): void {
    try {
      localStorage.removeItem('auth-token');
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

}


  






